import { useCallback } from "react";

import { buildStructuredSearchPayload } from "@/routes/request-logs/search/structured-search-payload";
import { useResetPageOnStructuredSearch } from "@/components/StructuredSearch/hooks/useResetPageOnStructuredSearch";
import { useStructuredSearchStore } from "@/components/StructuredSearch/stores";

export const useResetRequestLogsPageOnStructuredSearch = () => {
  const structuredSearchStore = useStructuredSearchStore();
  const getSearchSnapshot = useCallback(
    () =>
      buildStructuredSearchPayload(structuredSearchStore.filters, structuredSearchStore.dateRange),
    [structuredSearchStore],
  );

  useResetPageOnStructuredSearch(getSearchSnapshot);
};
